import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControlLabel as MuiFormControlLabel, Stack, styled, } from '@mui/material';
import { forwardRef } from 'react';
import { Checkbox, Paper, Typography } from '../../atoms';
import { Tooltip } from '../../legacy/components';
export const SelectableCard = forwardRef(function SelectableCard({ title, label, tooltip, image, error, ...rest }, ref) {
    return (_jsx(MuiFormControlLabel, { sx: (theme) => ({
            ariaLabel: title ?? '',
            maxWidth: '384px',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                margin: '0',
            },
        }), control: _jsxs(Paper, { width: "100%", children: [_jsxs(Stack, { direction: "row-reverse", alignItems: "center", justifyContent: "space-between", children: [_jsx(Checkbox, { ...rest, title: title, ref: ref }), tooltip && _jsx(Tooltip, { ...tooltip })] }), _jsxs(Stack, { alignItems: "center", justifyContent: "center", spacing: 104, sx: (theme) => ({
                        width: '100%',
                        [theme.breakpoints.down('sm')]: {
                            maxWidth: '320px',
                        },
                    }), children: [image && image, _jsx(Typography, { variant: "body1 semibold", color: "darkBlue", align: "center", children: title }), _jsx(Stack, { direction: "row", alignItems: "flex-start", justifyContent: "space-between", sx: {
                                width: 'fit-content',
                            }, children: label && (_jsx(TypographyStyled, { variant: "body1 regular", color: "darkBlue", minHeight: "80px", height: "100%", children: label })) })] })] }), label: "" }));
});
const TypographyStyled = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
    },
}));
